import type { KpiMetricType } from '../KpiSection/KpiSection.util';

// Index 0 corresponds to -52; Index 53 corresponds to +1
export const tcpCurveTargets: { [key in KpiMetricType | 'BASELINE']?: number[] } = {
  BASELINE: [
    0, 0, 0, 1, 1, 1, 2, 3, 4, 5, 6, 8, 9, 11, 13, 15, 17, 20, 22, 25, 29, 33, 37, 42, 47, 51, 56,
    61, 64, 68, 72, 75, 78, 82, 84, 87, 88, 90, 92, 93, 94, 95, 96, 96, 97, 98, 99, 100, 100, 100,
    100, 100, 100, 100,
  ],
  PERMITS_VERIFIED: [
    0, 0.0, 0.0, 0.0, 0.0, 0.0, 1.4, 2.9, 4.3, 5.7, 7.1, 8.6, 10.0, 11.4, 12.9, 14.3, 15.7, 17.1,
    18.6, 20.0, 24.3, 28.6, 32.9, 37.1, 41.4, 45.7, 50.0, 54.3, 58.6, 62.9, 67.1, 71.4, 75.7, 80.0,
    81.4, 82.9, 84.3, 85.7, 87.1, 88.6, 90.0, 91.4, 92.9, 94.3, 95.7, 97.1, 98.6, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0, 100.0,
  ],
  IDPS_AWAITING_AUTHORISATION: [
    0, 0.0, 0.0, 0.0, 0.0, 0.0, 1.4, 2.9, 4.3, 5.7, 7.1, 8.6, 10.0, 11.4, 12.9, 14.3, 15.7, 17.1,
    18.6, 20.0, 24.3, 28.6, 32.9, 37.1, 41.4, 45.7, 50.0, 54.3, 58.6, 62.9, 67.1, 71.4, 75.7, 80.0,
    81.4, 82.9, 84.3, 85.7, 87.1, 88.6, 90.0, 91.4, 92.9, 94.3, 95.7, 97.1, 98.6, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0, 100.0,
  ],
  PROCEDURES_APPROVED: [
    0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 2.0, 4.0, 6.0, 8.0, 10.0, 12.0, 14.0, 16.0,
    18.0, 20.0, 26.0, 32.0, 38.0, 44.0, 50.0, 56.0, 62.0, 68.0, 74.0, 80.0, 82.0, 84.0, 86.0, 88.0,
    90.0, 92.0, 94.0, 96.0, 98.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
  ],
  LINE_WALK_PACKS_APPROVED: [
    0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 1.5, 3.1, 4.6, 6.2, 7.7, 9.2, 10.8, 12.3, 13.8,
    15.4, 16.9, 18.5, 20.0, 24.6, 29.2, 33.8, 38.5, 43.1, 47.7, 52.3, 56.9, 61.5, 66.2, 70.8, 75.4,
    80.0, 81.7, 83.3, 85.0, 86.7, 88.3, 90.0, 91.7, 93.3, 95.0, 96.7, 98.3, 100.0, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0,
  ],
  GOC_READY_TO_USE: [
    0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 1.5, 3.1, 4.6, 6.2, 7.7, 9.2, 10.8, 12.3, 13.8,
    15.4, 16.9, 18.5, 20.0, 24.6, 29.2, 33.8, 38.5, 43.1, 47.7, 52.3, 56.9, 61.5, 66.2, 70.8, 75.4,
    80.0, 81.7, 83.3, 85.0, 86.7, 88.3, 90.0, 91.7, 93.3, 95.0, 96.7, 98.3, 100.0, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0,
  ],
  TEST_PACKS_APPROVED: [
    0, 0.0, 0.0, 0.0, 0.0, 0.0, 1.8, 3.6, 5.5, 7.3, 9.1, 10.9, 12.7, 14.5, 16.4, 18.2, 20.0, 25.5,
    30.9, 36.4, 41.8, 47.3, 52.7, 58.2, 63.6, 69.1, 74.5, 80.0, 81.8, 83.6, 85.5, 87.3, 89.1, 90.9,
    92.7, 94.5, 96.4, 98.2, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
  ],

  JOBS_AT_LEVEL_4_SCHEDULED: [
    0, 1.5, 3.1, 4.6, 6.2, 7.7, 9.2, 10.8, 12.3, 13.8, 15.4, 16.9, 18.5, 20.0, 24.6, 29.2, 33.8,
    38.5, 43.1, 47.7, 52.3, 56.9, 61.5, 66.2, 70.8, 75.4, 80.0, 81.5, 83.1, 84.6, 86.2, 87.7, 89.2,
    90.8, 92.3, 93.8, 95.4, 96.9, 98.5, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
  ],
  WORKPACKS_APPROVED: [
    0, 1.7, 3.3, 5.0, 6.7, 8.3, 10.0, 11.7, 13.3, 15.0, 16.7, 18.3, 20.0, 25.0, 30.0, 35.0, 40.0,
    45.0, 50.0, 55.0, 60.0, 65.0, 70.0, 75.0, 80.0, 81.7, 83.3, 85.0, 86.7, 88.3, 90.0, 91.7, 93.3,
    95.0, 96.7, 98.3, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
  ],
  LIFT_PLANS_APPROVED: [
    0, 1.3, 2.5, 3.8, 5.0, 6.3, 7.5, 8.8, 10.0, 11.3, 12.5, 13.8, 15.0, 16.3, 17.5, 18.8, 20.0,
    23.8, 27.5, 31.3, 35.0, 38.8, 42.5, 46.3, 50.0, 53.8, 57.5, 61.3, 65.0, 68.8, 72.5, 76.3, 80.0,
    81.3, 82.7, 84.0, 85.3, 86.7, 88.0, 89.3, 90.7, 92.0, 93.3, 94.7, 96.0, 97.3, 98.7, 100.0,
    100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
  ],
  SCAFFOLDS_SURVEYED_AND_PLANNED: [
    0, 1.7, 3.3, 5.0, 6.7, 8.3, 10.0, 11.7, 13.3, 15.0, 16.7, 18.3, 20.0, 25.0, 30.0, 35.0, 40.0,
    45.0, 50.0, 55.0, 60.0, 65.0, 70.0, 75.0, 80.0, 81.7, 83.3, 85.0, 86.7, 88.3, 90.0, 91.7, 93.3,
    95.0, 96.7, 98.3, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
  ],
  INSULATION_SURVEYED_AND_PLANNED: [
    0, 1.7, 3.3, 5.0, 6.7, 8.3, 10.0, 11.7, 13.3, 15.0, 16.7, 18.3, 20.0, 25.0, 30.0, 35.0, 40.0,
    45.0, 50.0, 55.0, 60.0, 65.0, 70.0, 75.0, 80.0, 81.7, 83.3, 85.0, 86.7, 88.3, 90.0, 91.7, 93.3,
    95.0, 96.7, 98.3, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
  ],
};

export const ocpCurveTargets: { [key in KpiMetricType | 'BASELINE']?: number[] } = {
  BASELINE: [
    0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 3, 4, 6, 8, 10, 11, 13, 15, 17, 20, 23, 26, 30, 35, 40, 45, 50,
    55, 60, 65, 68, 72, 75, 79, 82, 86, 87, 89, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 100, 100,
    100, 100, 100, 100,
  ],
  PERMITS_VERIFIED: [
    0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 1.5, 3.1, 4.6, 6.2, 7.7, 9.2, 10.8, 12.3, 13.8,
    15.4, 16.9, 18.5, 20.0, 24.6, 29.2, 33.8, 38.5, 43.1, 47.7, 52.3, 56.9, 61.5, 66.2, 70.8, 75.4,
    80.0, 81.7, 83.3, 85.0, 86.7, 88.3, 90.0, 91.7, 93.3, 95.0, 96.7, 98.3, 100.0, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0,
  ],
  IDPS_AWAITING_AUTHORISATION: [
    0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 1.5, 3.1, 4.6, 6.2, 7.7, 9.2, 10.8, 12.3, 13.8,
    15.4, 16.9, 18.5, 20.0, 24.6, 29.2, 33.8, 38.5, 43.1, 47.7, 52.3, 56.9, 61.5, 66.2, 70.8, 75.4,
    80.0, 81.7, 83.3, 85.0, 86.7, 88.3, 90.0, 91.7, 93.3, 95.0, 96.7, 98.3, 100.0, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0,
  ],
  PROCEDURES_APPROVED: [
    0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 2.0, 4.0, 6.0, 8.0, 10.0, 12.0, 14.0, 16.0,
    18.0, 20.0, 26.0, 32.0, 38.0, 44.0, 50.0, 56.0, 62.0, 68.0, 74.0, 80.0, 82.0, 84.0, 86.0, 88.0,
    90.0, 92.0, 94.0, 96.0, 98.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
  ],
  LINE_WALK_PACKS_APPROVED: [
    0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 1.5, 3.1, 4.6, 6.2, 7.7, 9.2, 10.8, 12.3, 13.8,
    15.4, 16.9, 18.5, 20.0, 24.6, 29.2, 33.8, 38.5, 43.1, 47.7, 52.3, 56.9, 61.5, 66.2, 70.8, 75.4,
    80.0, 81.7, 83.3, 85.0, 86.7, 88.3, 90.0, 91.7, 93.3, 95.0, 96.7, 98.3, 100.0, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0,
  ],
  GOC_READY_TO_USE: [
    0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 1.5, 3.1, 4.6, 6.2, 7.7, 9.2, 10.8, 12.3, 13.8,
    15.4, 16.9, 18.5, 20.0, 24.6, 29.2, 33.8, 38.5, 43.1, 47.7, 52.3, 56.9, 61.5, 66.2, 70.8, 75.4,
    80.0, 81.7, 83.3, 85.0, 86.7, 88.3, 90.0, 91.7, 93.3, 95.0, 96.7, 98.3, 100.0, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0,
  ],
  TEST_PACKS_APPROVED: [
    0, 0.0, 0.0, 0.0, 0.0, 0.0, 1.8, 3.6, 5.5, 7.3, 9.1, 10.9, 12.7, 14.5, 16.4, 18.2, 20.0, 25.5,
    30.9, 36.4, 41.8, 47.3, 52.7, 58.2, 63.6, 69.1, 74.5, 80.0, 81.8, 83.6, 85.5, 87.3, 89.1, 90.9,
    92.7, 94.5, 96.4, 98.2, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
  ],
  JOBS_AT_LEVEL_4_SCHEDULED: [
    0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 2.0, 4.0, 6.0, 8.0, 10.0, 12.0, 14.0, 16.0,
    18.0, 20.0, 26.0, 32.0, 38.0, 44.0, 50.0, 56.0, 62.0, 68.0, 74.0, 80.0, 82.0, 84.0, 86.0, 88.0,
    90.0, 92.0, 94.0, 96.0, 98.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
  ],
  WORKPACKS_APPROVED: [
    0, 1.7, 3.3, 5.0, 6.7, 8.3, 10.0, 11.7, 13.3, 15.0, 16.7, 18.3, 20.0, 25.0, 30.0, 35.0, 40.0,
    45.0, 50.0, 55.0, 60.0, 65.0, 70.0, 75.0, 80.0, 81.7, 83.3, 85.0, 86.7, 88.3, 90.0, 91.7, 93.3,
    95.0, 96.7, 98.3, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
  ],
  LIFT_PLANS_APPROVED: [
    0, 1.3, 2.5, 3.8, 5.0, 6.3, 7.5, 8.8, 10.0, 11.3, 12.5, 13.8, 15.0, 16.3, 17.5, 18.8, 20.0,
    23.8, 27.5, 31.3, 35.0, 38.8, 42.5, 46.3, 50.0, 53.8, 57.5, 61.3, 65.0, 68.8, 72.5, 76.3, 80.0,
    81.3, 82.7, 84.0, 85.3, 86.7, 88.0, 89.3, 90.7, 92.0, 93.3, 94.7, 96.0, 97.3, 98.7, 100.0,
    100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
  ],
  SCAFFOLDS_SURVEYED_AND_PLANNED: [
    0, 1.7, 3.3, 5.0, 6.7, 8.3, 10.0, 11.7, 13.3, 15.0, 16.7, 18.3, 20.0, 25.0, 30.0, 35.0, 40.0,
    45.0, 50.0, 55.0, 60.0, 65.0, 70.0, 75.0, 80.0, 81.7, 83.3, 85.0, 86.7, 88.3, 90.0, 91.7, 93.3,
    95.0, 96.7, 98.3, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
  ],
  INSULATION_SURVEYED_AND_PLANNED: [
    0, 1.7, 3.3, 5.0, 6.7, 8.3, 10.0, 11.7, 13.3, 15.0, 16.7, 18.3, 20.0, 25.0, 30.0, 35.0, 40.0,
    45.0, 50.0, 55.0, 60.0, 65.0, 70.0, 75.0, 80.0, 81.7, 83.3, 85.0, 86.7, 88.3, 90.0, 91.7, 93.3,
    95.0, 96.7, 98.3, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
    100.0, 100.0, 100.0, 100.0, 100.0, 100.0, 100.0,
  ],
};
